export enum CountryISOCodes {
  AE = 'AE',
  KE = 'KE',
  UG = 'UG',
}
